module.exports = __webpack_public_path__ + "img/1728520547601-509130e3-3238-409a-a777-76f3a76cb8e4.jpeg.88cc7ff1.webp";